import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './kundesla.list-view.html',
    styleUrls: ['./kundesla.list-view.scss']
})
export class KundeslaListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
